.aside {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 0.85rem;
  color: var(--color-ink);
  min-width: 0;
}

.heading {
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0.18em;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid var(--color-ink);
}

.section {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding: 14px 0;
}

.sectionHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.sectionTitle {
  flex: 1;
  text-align: left;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  font: inherit;
  font-weight: 700;
  font-size: 0.78rem;
  letter-spacing: 0.16em;
  color: var(--color-ink);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.toggle { font-size: 1.1rem; color: var(--color-ink-soft); }

.x {
  border: 0;
  background: transparent;
  cursor: pointer;
  font-size: 1rem;
  color: var(--color-ink-soft);
  padding: 0 4px;
}

.sectionBody {
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.rangeLabels {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  color: var(--color-ink-soft);
  margin-bottom: 4px;
}

.check :global(.MuiFormControlLabel-label) {
  font-size: 0.85rem;
  color: var(--color-ink);
}

.more {
  font-size: 0.8rem;
  color: var(--color-ink-soft);
  cursor: pointer;
  margin-top: 4px;
}

.clear {
  margin-top: 16px;
  background: transparent;
  border: 1px solid rgba(0, 0, 0, 0.18);
  padding: 8px 12px;
  font-size: 0.75rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  cursor: pointer;
  color: var(--color-ink);
}
